module.exports = __webpack_public_path__ + "img/logo-ecdc.911a6c01.png";